<template>
    <div>
        <sau-control-panel></sau-control-panel>
    </div>
</template>
<script>
import Access from '@js/components/service/common/_Access';
import ControlPanel from './_ControlPanel';
export default {
    components: {
        'sau-access': Access,
        'sau-control-panel': ControlPanel
    }
}
</script>
<style>
</style>
